"use client"

import { useCookies } from "src/hooks/useCookies";

export default function Wrapper({ children }: any) {
  useCookies()
  return <>{children}</>;
}
